import { HttpClient, HttpBackend } from '@angular/common/http';

import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { PublicPlannerEnum } from '../../../services/api-names';
import { SessionService } from '../../../services/session.service';
import {
  TECH_LIB_PORTAL_CONFIG,
  TechLibPortalConfig,
} from '../../../tech-lib-portal.interceptor';
import { Utils } from '../../../utils/utils';
import { EvalGoalInterface } from '../../financialplanning/request/interfaces/eval-goal.interface';
import { FeeInterface } from '../../financialplanning/request/interfaces/fee.interface';
import { FinancialPlanRefdataInterface } from '../../financialplanning/request/interfaces/financialplan-refdata.interface';
import { SimulationObjInterface } from '../../financialplanning/request/interfaces/simulation-obj.interface';
import { SimulationTargetGrowInterface } from '../../financialplanning/request/interfaces/simulation-taget-grow.interface';
import { PortfolioInterface } from '../../profileportfolio/request/interfaces/portfolio.interface';
import { CurrencyInterface } from '../request/interfaces/currency.interface';
import { TargetInterface } from '../request/interfaces/target.interface';

@Injectable({
  providedIn: 'root',
})
export class PublicplannerService {
  // public currencyDataSource = new BehaviorSubject<CurrencyInterface>({} as any);
  // public currencyData$ = this.currencyDataSource.asObservable();
  // public stepSource = new BehaviorSubject<number>(0);
  // public step$ = this.stepSource.asObservable();
  // public step1Source = new BehaviorSubject<boolean>(false);
  // public step1$ = this.step1Source.asObservable();
  // public step2Source = new BehaviorSubject<boolean>(false);
  // public step2$ = this.step2Source.asObservable();
  // public step3Source = new BehaviorSubject<boolean>(false);
  // public step3$ = this.step3Source.asObservable();
  // public step4Source = new BehaviorSubject<boolean>(false);
  // public step4$ = this.step4Source.asObservable();
  // public showQuestionSource = new BehaviorSubject<boolean>(true);
  // public showQuestion$ = this.showQuestionSource.asObservable();
  // public showHowLongSource = new BehaviorSubject<boolean>(false);
  // public showHowLong$ = this.showHowLongSource.asObservable();
  // public showMarketDeclineSource = new BehaviorSubject<boolean>(false);
  // public showMarketDecline$ = this.showMarketDeclineSource.asObservable();
  // public showProfilesSource = new BehaviorSubject<boolean>(false);
  // public showProfiles$ = this.showProfilesSource.asObservable();
  // public gonextSource = new BehaviorSubject<boolean>(false);
  // public gonext$ = this.gonextSource.asObservable();
  // public gobackSource = new BehaviorSubject<boolean>(false);
  // public goback$ = this.gobackSource.asObservable();
  // public simulationTagetGrowObj: SimulationTargetGrowInterface = {};
  // public simulationObjSource = new BehaviorSubject<SimulationObjInterface>(
  //   {} as any
  // );
  // public simulationObj$ = this.simulationObjSource.asObservable();
  // public fpReferenceDataSource =
  //   new BehaviorSubject<FinancialPlanRefdataInterface>({} as any); //Inicializo el BehaviorSubject vacio con {} as any para queno de fallo al inicializarlo null
  // public fpReferenceData$ = this.fpReferenceDataSource.asObservable();
  // public targetSelectSource = new BehaviorSubject<TargetInterface>({} as any); //Inicializo el BehaviorSubject vacio con {} as any para queno de fallo al inicializarlo null
  // public targetSelect$ = this.targetSelectSource.asObservable();
  // public evalGoalObjSource = new BehaviorSubject<EvalGoalInterface>({} as any); //Inicializo el BehaviorSubject vacio con {} as any para queno de fallo al inicializarlo null
  // public evalGoalObj$ = this.evalGoalObjSource.asObservable();
  // public profileAnalysisSource = new BehaviorSubject<portfolioInterface>(
  //   {} as any
  // ); //Inicializo el BehaviorSubject vacio con {} as any para queno de fallo al inicializarlo null
  // public profileAnalysis$ = this.profileAnalysisSource.asObservable();
  // public resetTimeHorizonSouce = new BehaviorSubject<string>('');
  // public resetTimeHorizon$ = this.resetTimeHorizonSouce.asObservable();
  // public resetReactionSouce = new BehaviorSubject<string>('');
  // public resetReaction$ = this.resetReactionSouce.asObservable();
  // public resetProfileSouce = new BehaviorSubject<string>('');
  // public resetProfile$ = this.resetProfileSouce.asObservable();
  // public progressSource = new BehaviorSubject<number>(0);
  // public progress$ = this.progressSource.asObservable();
  // public showProgressSource = new BehaviorSubject<boolean>(true);
  // public showProgress$ = this.showProgressSource.asObservable();
  // public textSuggestedSource = new BehaviorSubject<boolean>(true);
  // public textSuggested$ = this.textSuggestedSource.asObservable();
  // public suggestedProfileSource = new BehaviorSubject<number>(0);
  // public suggestedProfile$ = this.suggestedProfileSource.asObservable();
  // public swipeInfoSource = new BehaviorSubject<boolean>(false);
  // public swipeInfo$ = this.swipeInfoSource.asObservable();
  // public showModalSuggested: boolean = true;
  // public reaction: string = '';
  // public profile: number = 0;

  constructor(
    @Inject(TECH_LIB_PORTAL_CONFIG) private config: TechLibPortalConfig,
    private session: SessionService,
    private http: HttpClient
  ) {}

  private updateSession() {
    this.config.sessionToken = this.session.sessionToken;
    this.config.domain = this.session.domain;
    this.config.clientCode = this.session.clientCode;
  }

  public getProfileAnalysis(type: string, profileId: string, amount: string) {
    // this.updateSession();
    let url = Utils.formatString(
      this.config.baseApi + PublicPlannerEnum.apirest_profile_analysis,
      [type, profileId, amount]
    );

    return this.http.get<any>(url).pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        return throwError(err);
      })
    );
  }

  public getFinancialPlanRefData() {
    let url = this.config.baseApi + PublicPlannerEnum.apirest_eval_refdata;

    return this.http.get<any>(url).pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        return throwError(err);
      })
    );
  }

  public getEvalGoal(target: TargetInterface, obj: SimulationObjInterface) {
    this.updateSession();
    let url = this.config.baseApi + PublicPlannerEnum.apirest_eval;

    let bodyRequest;
    switch (target.ServiceModelCode) {
      case 'H':
      case 'AP':
        bodyRequest = {
          Currency: obj.Currency,
          ProfileId: obj.ProfileId,
          GoalAmount: obj.GoalAmount,
          TimeHorizon: obj.TimeHorizon,
          InitialContributionAmount: obj.InitialContributionAmount,
          PeriodicContributionAmount: obj.PeriodicContributionAmount,
          PeriodicContributionFrequency: obj.PeriodicContributionFrequency,
          Priority: obj.Priority,
          InitialDate: obj.InitialDate,
          Type: target.Type,
          Name: target.Name,
          PayeeDeliveryCode: obj.PayeeDeliveryCode,
        };
        break;
      case 'J':
        bodyRequest = {
          Currency: obj.Currency,
          ProfileId: obj.ProfileId,
          TimeHorizon: obj.TimeHorizon,
          InitialContributionAmount: obj.InitialContributionAmount,
          PeriodicContributionAmount: obj.PeriodicContributionAmount,
          PeriodicContributionFrequency: obj.PeriodicContributionFrequency,
          WithdrawlTimeHorizon: obj.WithdrawlTimeHorizon,
          AnnualIncomes: obj.AnnualIncomes,
          LivingStandards: obj.LivingStandards,
          SocialSecurityIncomePerc: obj.SocialSecurityIncomePerc,
          Priority: obj.Priority,
          InitialDate: obj.InitialDate,
          Type: target.Type,
          Name: target.Name,
          PayeeDeliveryCode: obj.PayeeDeliveryCode,
        };
        break;
      default:
        break;
    }
    bodyRequest = JSON.stringify(bodyRequest);
    return this.http.post<any>(url, bodyRequest).pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        return throwError(err);
      })
    );
  }

  public getFees(type: string, profileId: string) {
    let url = Utils.formatString(
      this.config.baseApi + PublicPlannerEnum.apirest_fees,
      [type, profileId]
    );

    return this.http.get<FeeInterface>(url).pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        return throwError(err);
      })
    );
  }

  public getRiskprofile(type: string) {
    let url = Utils.formatString(
      this.config.baseApi + PublicPlannerEnum.apirest_riskprofile,
      [type]
    );

    return this.http.get<any>(url).pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        return throwError(err);
      })
    );
  }

  public saveGoal(goal: SimulationObjInterface) {
    let url = this.config.baseApi + PublicPlannerEnum.apirest_goal;

    let bodyRequest = JSON.stringify(goal);
    return this.http.post<any>(url, bodyRequest).pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        return throwError(err);
      })
    );
  }

  public saveGoalPortfolio(goalId: string, portfolioCode: string) {
    let url = Utils.formatString(
      this.config.baseApi + PublicPlannerEnum.apirest_goal_portfolio,
      [goalId]
    );

    //let bodyRequest = { PortfolioCodes: [portfolioCode] };
    let bodyRequest = [portfolioCode];

    return this.http.post<any>(url, bodyRequest).pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        return throwError(err);
      })
    );
  }

  public funding(
    initialContributionAmount: string,
    currency: string,
    modelPortfolioCode: string,
    portfolioCode: string,
    payeeDeliveryCode: string
  ) {
    let url = Utils.formatString(
      this.config.baseApi + PublicPlannerEnum.apirest_funding,
      [portfolioCode]
    );

    let bodyRequest = {
      Amount: initialContributionAmount,
      Currency: currency,
      FundTransfers: [],
      ModelPortfolioCode: modelPortfolioCode,
      PayeeDeliveryCode: payeeDeliveryCode,
    };

    return this.http.post<any>(url, bodyRequest).pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        return throwError(err);
      })
    );
  }
}
